<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('모바일 포스 배너 타입')">
              <code-combo
                :data="mobilePosBannerTp"
                :model="searchForm.mobilePosBannerTpCd"
                @change="
                  ;(searchForm.mobilePosBannerTpCd = $event.cd), (searchForm.mobilePosBannerTpVal = $event.val)
                "></code-combo>
            </el-form-item>
            <!--						<el-form-item :label="$t('모바일 포스 배너 타입')">-->
            <!--							<el-select v-model="searchForm.mobilePosBannerTp" @change="inputForm.mobilePosBannerTp = $event" style="width: 100%;">-->
            <!--								<el-option key=0 :label="$t('전체')" :value=null</el-option>-->
            <!--								<el-option v-for="item in searchForm.mobilePosBannerTp" :key="item.cd" :label="item.nmLan" :value = "item.cd"></el-option>-->
            <!--							</el-select>-->
            <!--						</el-form-item>-->
          </el-col>
          <!--					<el-col :md="8">-->
          <!--						<el-form-item :label="$t('배너명')">-->
          <!--							<el-input v-model="searchForm.bannerNm" @keyup.enter.native="search" clearable @change="searchForm.bannerNm = $event"></el-input>-->
          <!--						</el-form-item>-->
          <!--					</el-col>-->
          <el-col :md="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('MobilePosBannerForStoreSearch')"
        :size="size"
        @click="search"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('MobilePosBannerForStoreAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('MobilePosBannerForStoreUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('MobilePosBannerForStoreDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <!--			<el-button v-if="checkAuthActionAccess('MobilePosBannerForStoreUse')" :size="size"  @click="use" icon="el-icon-check" :disabled="btn.delDisabled" >{{ $t('사용') }}</el-button>-->
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked">
      <el-table-column
        :label="tableData.length.toString()"
        type="index"
        width="55"
        align="center"
        sortable
        label-class-name="data_cnt"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>

      <el-table-column :label="$t('모바일 포스 배너 이미지')" prop="bannerImg" min-width="350" align="center">
        <template slot-scope="scope">
          <!--					<el-button type="text" @click="clickUp(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;{{ scope.row.smenuNmLan }}</el-button>-->
          <fallback-image
            style="width: 300px; height: 81px"
            v-if="scope.row.type === 'image'"
            :src="resolvImage(scope.row.bannerImg)"
            fit="fill"
            @click="clickUp(scope.row)"></fallback-image>
          <video
            style="width: 300px; height: 81px"
            v-if="scope.row.type === 'video'"
            :src="resolvImage(scope.row.bannerVideo)"
            fit="fill"
            @click="clickUp(scope.row)"></video>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('배너 유형')"
        prop="type"
        min-width="110"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('모바일 포스 배너 타입')"
        prop="mobilePosBannerTpNm"
        min-width="110"
        align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="110"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
    </el-table>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        label-width="140px"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-tabs v-model="activiTabMobilePosBanner">
          <el-tab-pane :label="$t('기본 정보')" name="info">
            <el-row :gutter="20">
              <el-col :md="24">
                <el-row :gutter="20">
                  <el-col :md="12" v-if="inputForm.type === 'image'">
                    <el-form-item :label="$t('배너 이미지')" :error="formError['bannerImgFile']" required>
                      <el-upload
                        action=""
                        class="avatar-uploader"
                        accept="image/*"
                        :show-file-list="false"
                        :auto-upload="false"
                        :on-change="bannerImgChange"
                        :disabled="!inputForm.mobilePosBannerTpSelected">
                        <fallback-image
                          native
                          v-if="inputForm.bannerImg || inputForm.bannerImgFile"
                          :src="this.resolvImage(inputForm.bannerImgFile)"
                          class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div v-if="inputForm.mobilePosBannerTpSelected">
                          <!--													<span slot="tip" class="el-upload__tip" >({{ mobilePosBannerTpNm }}) {{ imgWidth }}x{{ imgHeight }}</span>-->
                          <span slot="tip" class="el-upload__tip">{{ $t(' 픽셀 이미지만 업로드 가능합니다.') }}</span>
                        </div>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12" v-if="inputForm.type === 'video'">
                    <el-form-item :label="$t('배너 영상')" :error="formError['bannerVideoFile']" required>
                      <el-upload
                        action=""
                        class="avatar-uploader"
                        :show-file-list="true"
                        :auto-upload="false"
                        :on-change="bannerVideoChange">
                        <video
                          v-if="inputForm.bannerVideo"
                          :src="this.resolvImage(inputForm.bannerVideo)"
                          class="avatar"></video>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div>
                          <span slot="tip" class="el-upload__tip">{{ $t('영상 업로드.') }}</span>
                        </div>
                      </el-upload>
                    </el-form-item>
                  </el-col>

                  <el-col :md="12">
                    <el-form-item :label="$t('모바일 포스 배너 타입')" :error="formError.mobilePosBannerTp" required>
                      <code-combo
                        :data="mobilePosBannerTp"
                        :model="inputForm.mobilePosBannerTp"
                        @change="inputForm.mobilePosBannerTp = $event"></code-combo>
                    </el-form-item>
                    <el-form-item :label="$t('배너 종류')" required>
                      <combo :data="mobilePosTypes" :model="inputForm.type" @change="inputForm.type = $event"></combo>
                    </el-form-item>
                    <el-form-item :label="$t('사용 가능 여부')" required>
                      <combo
                        :data="mainVue.code.useYn"
                        :model="inputForm.useYn"
                        @change="inputForm.useYn = $event"></combo>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :md="12"> </el-col>

                  <el-col :md="12"> </el-col>
                </el-row>

                <!--								<el-form-item :label="$t('설명')" :error="formError.smenuDesc">-->
                <!--									<el-input v-model="inputForm.smenuDesc" type="textarea" maxlength="250" show-word-limit></el-input>-->
                <!--								</el-form-item>-->
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="dialogFormVisible = false">{{ $t('닫기') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { initData } from '@/utils/constants'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/mobile-pos-banner/store'

    data.mobilePosBannerTp = []
    data.mobilePosBannerTpNm = '모바일 메인 배너'

    data.mobilePosTypes = [
      { label: '이미지', value: 'image' },
      { label: '영상', value: 'video' },
    ]
    data.bannerVideoFile = null

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.activiTab = ''

    data.activiTabMobilePosBanner = 'info'

    data.dictionaryDialogFormVisible = false
    data.searchText = ''

    // 이미지 사이즈
    data.imgWidth = 0
    data.imgHeight = 0

    data.listTitle = this.$t('재료 리스트')
    data.dataTitle = this.$t('재료')
    data.listBtn = this.$t('제거')
    data.dataBtn = this.$t('설정')

    return data
  },
  created: function () {
    this.search()
    this.initMobilePosBannerTp()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    'inputForm.mobilePosBannerTp': function (newVal) {
      // TODO 이미지 값 초기화
      this.inputForm.mobilePosBannerTpSelected = false

      if (newVal.ref1 == 'Y') {
        this.imgWidth = Number(newVal.ref2)
        this.imgHeight = Number(newVal.ref3)
        this.mobilePosBannerTpNm = newVal.nm
        this.inputForm.mobilePosBannerTpSelected = true
      }
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        mobilePosBannerTpVal: '',
        mobilePosBannerTpCd: '',
        mobilePosBannerTpNm: '',
        useYn: 'Y',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',

        mobilePosBannerCd: 0,
        bannerImg: '',
        bannerImgFile: '',
        bannerVideo: '',
        mobilePosBannerTp: '',
        mobilePosBanner: null,

        mobilePosBannerTpSelected: false,

        selectType: { label: '이미지', value: 'image' },
        type: 'video',

        store: { storeCd: null },
        useYn: 'Y',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        bannerImgFile: '',
        bannerVideoFile: '',
        mobilePosBannerTp: '',
        useYn: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].mobilePosBannerCd
      }
    },
    // 입력폼 포스 선택 이벤트
    posInputSelect: function (posCd) {
      for (var i = 0, len = this.pos.length; i < len; i++) {
        if (posCd == this.pos[i].posCd) {
          if (this.inputForm.statu == 'U') {
          }
          break
        }
      }
    },
    // 포스 배너
    initMobilePosBannerTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/MOBILE_POS_BANNER_TP',
        null,
        function (result) {
          this.mobilePosBannerTp = result
        }.bind(this),
        false
      )
    },
    // 추가
    add: function () {
      this.activiTabMobilePosBanner = 'info'
      this.formError = this.initFormError()
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('모바일 포스 배너 추가')

      this.dialogFormVisible = true
      this.btn.saveDisabled = false
    },
    // 메뉴 클릭해서 수정
    clickUp: function (row) {
      this.handleRowClick(row)
      this.up()
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.mobilePosBannerCd,
        function (result) {
          this.activiTabMobilePosBanner = 'info'
          result.statu = 'U'
          result.title = this.$t('모바일 포스 배너 정보 수정')

          result.bannerImgFile = result.bannerImg

          this.bannerVideoFile = null
          this.inputForm = result

          this.formError = this.initFormError()

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this)
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result
          console.log(result)

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.formError = this.initFormError()
        }.bind(this)
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('모바일 포스 배너 이미지를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 반영
    use: function () {
      this.mainVue
        .$confirm(this.$t('메뉴 정보를 사용으로 설정 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('사용'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.up(
              this.url + '/use/' + this.checkedData.join(','),
              null,
              null,
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('사용 설정 성공') })
                this.searchForm.useYn = 'Y'
                this.search()
              }.bind(this)
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('사용 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if (this.inputForm.type === 'image') {
        if (util.isEmpty(this.inputForm.bannerImgFile)) {
          this.formError.bannerImgFile = this.$t('모바일 포스 배너 이미지를 선택 하여 주십시오.')
          return
        }

        if ('I' === this.inputForm.statu) {
          this.mainVue.$axios.add(
            this.url,
            this.inputForm,
            this.formError,
            function (result) {
              this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
              this.dialogFormVisible = false
              this.search()
            }.bind(this)
          )
        } else {
          this.mainVue.$axios.up(
            this.url + '/' + this.inputForm.mobilePosBannerCd,
            this.inputForm,
            this.formError,
            function (result) {
              this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
              this.dialogFormVisible = false
              this.search()
            }.bind(this)
          )
        }
      } else if (this.inputForm.type === 'video') {
        if (util.isEmpty(this.bannerVideoFile)) {
          this.formError.bannerVideoFile = this.$t('모바일 포스 배너 영상을 등록 하여 주십시오.')
          return
        }
        let multipartFormData = new FormData()
        multipartFormData.append('bannerVideoFile', this.bannerVideoFile)
        multipartFormData.append('mobilePosBannerCd', this.inputForm.mobilePosBannerCd)
        let length = this.bannerVideoFile.length
        this.$axios
          .post(this.url + '/video', multipartFormData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Content-Length': length,
            },
          })
          .then((response) => {
            this.inputForm.bannerVideo = response.data

            if ('I' === this.inputForm.statu) {
              this.mainVue.$axios.add(
                this.url,
                this.inputForm,
                this.formError,
                function (result) {
                  this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
                  this.dialogFormVisible = false
                  this.search()
                }.bind(this)
              )
            } else {
              this.mainVue.$axios.up(
                this.url + '/' + this.inputForm.mobilePosBannerCd,
                this.inputForm,
                this.formError,
                function (result) {
                  this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
                  this.dialogFormVisible = false
                  this.search()
                }.bind(this)
              )
            }
          })
          .catch((error) => {
            console.log(error)
            return
          })
      }
    },
    // 이미지 선택
    bannerImgChange: function (file) {
      util.imgToBase64(
        URL.createObjectURL(file.raw),
        file.raw.type,
        function (data, img) {
          var width = this.imgWidth
          var height = this.imgHeight

          // if (width != img.width || height != img.height) {
          // 	this.mainVue.$message({ type: 'warning', message: "[[#{"+width+"x"+height+" 픽셀 이미지만 업로드 가능합니다.}]]" });
          // } else {
          this.inputForm.bannerImgFile = data
          // }
        }.bind(this)
      )
    },
    // 영상 선택
    bannerVideoChange: function (file) {
      this.bannerVideoFile = file.raw
    },
  },
}
</script>

<style scoped>
.el-transfer-panel {
  width: 300px;
  height: 400px;
}

.el-transfer-panel__body {
  height: 354px;
}

.el-transfer-panel__list {
  height: 354px;
}

.el-transfer-panel__item {
  width: 240px;
}

.el-input-number__decrease,
.el-input-number__increase {
  background: white;
}
</style>
